var $6051e1035ff73e7b$exports = {};
$6051e1035ff73e7b$exports = {
    "help": `\u{8AAA}\u{660E}`,
    "info": `\u{8CC7}\u{8A0A}`
};


export {$6051e1035ff73e7b$exports as default};
//# sourceMappingURL=zh-TW.module.js.map
